const data_kbm_pr = [
    { umur: 0, kbm: 0 },
    { umur: 1, kbm: 0.8 },
    { umur: 2, kbm: 0.9 },
    { umur: 3, kbm: 0.8 },
    { umur: 4, kbm: 0.6 },
    { umur: 5, kbm: 0.5 },
    { umur: 6, kbm: 0.4 },
    { umur: 7, kbm: 0.3 },
    { umur: 8, kbm: 0.3 },
    { umur: 9, kbm: 0.3 },
    { umur: 10, kbm: 0.3 },
    { umur: 11, kbm: 0.2 },
    { umur: 12, kbm: 0.2 },
    { umur: 13, kbm: 0.2 },
    { umur: 14, kbm: 0.2 },
    { umur: 15, kbm: 0.2 },
    { umur: 16, kbm: 0.2 },
    { umur: 17, kbm: 0.2 },
    { umur: 18, kbm: 0.2 },
    { umur: 19, kbm: 0.2 },
    { umur: 20, kbm: 0.2 },
    { umur: 21, kbm: 0.2 },
    { umur: 22, kbm: 0.2 },
    { umur: 23, kbm: 0.2 },
    { umur: 24, kbm: 0.2 },
    { umur: 25, kbm: 0.2 },
    { umur: 26, kbm: 0.2 },
    { umur: 27, kbm: 0.2 },
    { umur: 28, kbm: 0.2 },
    { umur: 29, kbm: 0.2 },
    { umur: 30, kbm: 0.2 },
    { umur: 31, kbm: 0.2 },
    { umur: 32, kbm: 0.2 },
    { umur: 33, kbm: 0.2 },
    { umur: 34, kbm: 0.2 },
    { umur: 35, kbm: 0.2 },
    { umur: 36, kbm: 0.2 },
    { umur: 37, kbm: 0.2 },
    { umur: 38, kbm: 0.2 },
    { umur: 39, kbm: 0.2 },
    { umur: 40, kbm: 0.2 },
    { umur: 41, kbm: 0.2 },
    { umur: 42, kbm: 0.2 },
    { umur: 43, kbm: 0.2 },
    { umur: 44, kbm: 0.2 },
    { umur: 45, kbm: 0.2 },
    { umur: 46, kbm: 0.2 },
    { umur: 47, kbm: 0.2 },
    { umur: 48, kbm: 0.2 },
    { umur: 49, kbm: 0.2 },
    { umur: 50, kbm: 0.2 },
    { umur: 51, kbm: 0.2 },
    { umur: 52, kbm: 0.2 },
    { umur: 53, kbm: 0.2 },
    { umur: 54, kbm: 0.2 },
    { umur: 55, kbm: 0.2 },
    { umur: 56, kbm: 0.2 },
    { umur: 57, kbm: 0.2 },
    { umur: 58, kbm: 0.2 },
    { umur: 59, kbm: 0.2 },
    { umur: 60, kbm: 0.2 },
];

export default data_kbm_pr;
